
/**
 * Extract the first paragraph text from editor blocks
 * @param blocks Editor blocks
 * @returns The plain text of the first paragraph
 */
export const getFirstParagraphText = (blocks: any[]): string => {
  if (!blocks || blocks.length === 0) return '';
  
  // Look for the first paragraph block
  const firstParagraph = blocks.find(block => block.type === 'paragraph');
  if (firstParagraph && firstParagraph.data && firstParagraph.data.text) {
    // Remove HTML tags and trim
    return firstParagraph.data.text.replace(/<[^>]*>/g, '').trim();
  }
  
  return '';
};

/**
 * Truncate a description to the proper SEO length
 * @param text Text to truncate
 * @param maxLength Maximum length
 * @returns Truncated text with ellipsis if needed
 */
export const truncateForSeo = (text: string, maxLength: number = 160): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
};
